import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { GrassDivider, BranchDecoration } from './SectionDivider';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 overflow-hidden bg-brand-black" data-id="element-124">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-125">
        <img src="https://cdn.magicpatterns.com/uploads/va8m7kAHdGjyD7NMC2vRKo/heylloyd-image-1775569938042.png" alt="Beautifully landscaped yard" className="w-full h-full object-cover" data-id="element-126" />
        <div className="absolute inset-0 bg-black/70 mix-blend-multiply" data-id="element-127"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-transparent to-transparent" data-id="element-128"></div>
      </div>

      {/* Decorative Elements */}
      <BranchDecoration className="absolute top-24 left-10 w-32 h-32 text-brand-gold opacity-15 z-10 -scale-x-100" data-id="element-129" />
      <BranchDecoration className="absolute bottom-32 right-10 w-48 h-48 text-brand-gold opacity-15 z-10" data-id="element-130" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white" data-id="element-131">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-white" data-id="element-132">
          Finally — A Yard You're Proud To Come Home To Every Single Day
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg sm:text-xl md:text-2xl font-light mb-10 text-gray-300 max-w-3xl mx-auto" data-id="element-133">
          Chattanooga's Friendly, Professional Landscaping & Junk Removal Team —
          Here To Make Your Property Shine
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-134">
          <a href="tel:4233203426" className="inline-flex items-center gap-3 bg-brand-gold text-black px-8 py-4 rounded-full text-lg font-bold hover:bg-brand-goldLight transition-all transform hover:scale-105 shadow-lg" data-id="element-135">
            <Phone size={24} data-id="element-136" />
            Get Your Free Estimate
          </a>
        </motion.div>
      </div>
    </section>;
}